import { render, staticRenderFns } from "./Visor.vue?vue&type=template&id=3ed2e73e&"
import script from "./Visor.vue?vue&type=script&lang=js&"
export * from "./Visor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports